import { TAB_NOTES, TAB_ARCHIVE } from '../utils/index.js';

class NavTabs extends HTMLElement {
  _activeCount = 0;
  _archivedCount = 0;
  _boundHandlers = new Map();

  static observedAttributes = ['active-tab'];

  constructor() {
    super();
  }

  connectedCallback() {
    this.render();
    this._attachEventListeners();
  }

  disconnectedCallback() {
    this._removeEventListeners();
  }

  attributeChangedCallback() {
    this.render();
    this._attachEventListeners();
  }

  get activeTab() {
    return this.getAttribute('active-tab') || TAB_NOTES;
  }

  set activeTab(value) {
    this.setAttribute('active-tab', value);
  }

  setCount(activeCount, archivedCount) {
    this._activeCount = activeCount;
    this._archivedCount = archivedCount;
    this.render();
    this._attachEventListeners();
  }

  _removeEventListeners() {
    this._boundHandlers.forEach((handler, element) => {
      element.removeEventListener('click', handler);
    });
    this._boundHandlers.clear();
  }

  _attachEventListeners() {
    const tabs = this.querySelectorAll('.nav-tabs-btn');
    tabs.forEach((tab) => {
      const handler = () => {
        const tabValue = tab.dataset.tab;
        this.activeTab = tabValue;
        this.dispatchEvent(
          new CustomEvent('tab-changed', {
            detail: { tab: tabValue },
            bubbles: true,
          })
        );
      };
      tab.addEventListener('click', handler);
      this._boundHandlers.set(tab, handler);
    });
  }

  render() {
    this._removeEventListeners();

    const notesActive = this.activeTab === TAB_NOTES ? 'active' : '';
    const archiveActive = this.activeTab === TAB_ARCHIVE ? 'active' : '';

    this.innerHTML = `
      <nav class="nav-tabs-container" role="tablist" aria-label="Note categories">
        <button 
          class="nav-tabs-btn ${notesActive}" 
          data-tab="${TAB_NOTES}" 
          role="tab" 
          aria-selected="${this.activeTab === TAB_NOTES}"
          aria-controls="noteListContainer"
        >
          <span class="material-symbols-outlined" aria-hidden="true">description</span>
          All Notes
          <span class="nav-tabs-count" aria-label="${this._activeCount} notes">${this._activeCount}</span>
        </button>
        <button 
          class="nav-tabs-btn ${archiveActive}" 
          data-tab="${TAB_ARCHIVE}" 
          role="tab" 
          aria-selected="${this.activeTab === TAB_ARCHIVE}"
          aria-controls="noteListContainer"
        >
          <span class="material-symbols-outlined" aria-hidden="true">archive</span>
          Archive
          <span class="nav-tabs-count" aria-label="${this._archivedCount} archived notes">${this._archivedCount}</span>
        </button>
      </nav>
    `;
  }
}

customElements.define('nav-tabs', NavTabs);
